import React, { useState, useRef } from "react";
import { Modal, Button } from "react-bootstrap";
import { createModal } from "react-modal-promise";
import daehan from "../../../images/DaehanSteel.png";
import yksteel from "../../../images/yksteel_logo.png";
import { useReactToPrint } from "react-to-print";

const WeighingCertificatePop = (props) => {
  const componentRef = useRef();
  const [show, setShow] = useState(true);

  //console.log(props);
  const handleClose = (returnData) => {
    setShow(false);
  };

  const handleOk = useReactToPrint({
    content: () => componentRef.current,
  });

  return (
    <>
      <Modal show={show} onHide={() => handleClose(false)} size="lg">
        <Modal.Header closeButton>
          <Modal.Title>계 량 증 명 서</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div ref={componentRef} style={{ paddingTop: "50px" }}>
            <div id="UserDIV" style={{ cursor: "not-allowed" }}>
              <table
                align="center"
                className="no_action"
                style={{
                  width: "670px",
                  borderCollapse: "collapse",
                  borderImage: "none",
                }}
                border="0"
                cellspacing="0"
                cellpadding="0"
              >
                <tbody>
                  <tr style={{ height: "80px" }}>
                    <td
                      style={{
                        position: "relative",
                        border: "rgb(240, 240, 240)",
                        width: "170px",
                        textAlign: "center",
                        color: "rgb(0, 0, 0)",
                        textIndent: "0px",
                        fontSize: "12px",
                        fontStyle: "normal",
                        fontWeight: "400",
                        textDecoration: "none",
                        verticalAlign: "top",
                        borderImage: "none",
                      }}
                    >
                      <font className="bigtitle">
                        <h1>
                          <div
                            className="UserEditSpan"
                            style={{
                              wordBreak: "break-all",
                              width: "100%",
                              boxSizing: "border-box",
                              cursor: "text",
                              padding: "2px 5px 3px 5px",
                              textDecoration: "underline",
                              fontWeight: "400",
                            }}
                            contenteditable={true}
                          >
                            계량증명서
                          </div>
                        </h1>
                      </font>
                    </td>
                  </tr>
                  <tr style={{ height: "22px" }}>
                    <td
                      style={{
                        width: "670px",
                        textAlign: "left",
                        color: "rgb(0, 0, 0)",
                        textIndent: "0px",
                        fontFamily: "nanumM",
                        fontSize: "12px",
                        fontStyle: "normal",
                        fontWeight: "400",
                        textDecoration: "none",
                        verticalAlign: "middle",
                        borderTopColor: "rgb(240, 240, 240)",
                        borderRightColor: "rgb(240, 240, 240)",
                        borderBottomColor: "rgb(240, 240, 240)",
                      }}
                      colspan="2"
                    ></td>
                  </tr>
                </tbody>
              </table>
              <table
                align="center"
                className="actiont"
                border="0"
                cellspacing="0"
                cellpadding="0"
              >
                <tr>
                  <th>계량일자</th>
                  <td>{props?.wghtDt}</td>
                </tr>
                <tr>
                  <th>차량번호</th>
                  <td>{props?.vhclNo}</td>
                </tr>
                <tr>
                  <th>거래처</th>
                  <td>{props?.vndrNm}</td>
                </tr>
                <tr>
                  <th>품 명</th>
                  <td>원자재</td>
                </tr>
                <tr>
                  <th>등 급</th>
                  <td>{props?.cnfGrd}</td>
                </tr>
                <tr>
                  <th>입차중량</th>
                  <td>
                    {props?.inWgtDt?.substr(11, 5)} &nbsp;
                    {props?.inWgt
                      ?.toString()
                      .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                    KG
                  </td>
                </tr>
                <tr>
                  <th>출차중량</th>
                  <td>
                    {props?.outWgtDt?.substr(11, 5)} &nbsp;
                    {props?.outWgt
                      ?.toString()
                      .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                    KG
                  </td>
                </tr>
                <tr>
                  <th>감 량</th>
                  <td>
                    {props?.wtredtCd
                      ?.toString()
                      .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                    KG
                  </td>
                </tr>
                <tr>
                  <th>입고중량</th>
                  <td>
                    {props?.realWgt
                      ?.toString()
                      .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                    KG
                  </td>
                </tr>
                <tr>
                  <th>비고</th>
                  <td>{props?.reduceNm}</td>
                </tr>
                <tr>
                  <th>계근번호</th>
                  <td>{props?.scalNumb}</td>
                </tr>
              </table>
              <table
                align="center"
                className="no_action"
                style={{
                  width: "670px",
                  height: "23px",
                  borderCollapse: "collapse",
                  borderImage: "none",
                }}
                border="0"
                cellspacing="0"
                cellpadding="0"
              >
                <tbody>
                  <tr style={{ height: "23px" }}>
                    <td
                      style={{
                        border: "0px rgb(0, 0, 0)",
                        width: "670px",
                        textAlign: "left",
                        color: "rgb(0, 0, 0)",
                        textIndent: "0px",
                        fontFamily: "nanumM",
                        fontZize: "12px",
                        fontStyle: "normal",
                        fontWeight: "400",
                        textDecoration: "none",
                        verticalAlign: "middle",
                        backgroundRepeat: "no-repeat",
                      }}
                      scope=""
                    >
                      <span style={{ marginLeft: "3px", position: "absolute" }}>
                        <div
                          className="UserEditSpan"
                          style={{
                            wordBreak: "break-all",
                            width: "100%",
                            boxSizing: "border-box",
                            cursor: "text",
                            padding: "2px 5px 3px 5px",
                          }}
                          contenteditable={true}
                        >
                          <br />
                        </div>
                      </span>
                      <span
                        style={{ left: "48%", position: "absolute" }}
                      ></span>
                      <p
                        style={{
                          margin: "1rem",
                          marginRight: "120px",
                          textAlign: "right",
                          fontSize: "1.3rem",
                        }}
                      >
                        위와 같이 계량함을 증명함
                      </p>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div className="printwrap">
              <img
                src={props.systemCd === "DH" ? daehan : yksteel}
                width={props.systemCd === "DH" ? "300" : "345"}
                alt="daehansteel"
              />
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="primary" onClick={() => handleOk(true)}>
            출력
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export const ModalWeighingCertificatePop = createModal(WeighingCertificatePop);

export default WeighingCertificatePop;
